import React from 'react'
import { Link } from 'react-router-dom';
import Svg from '../Svg';


export default function Header() {
    return (
        <div className='site-header border-0'>
            <div className="container">
                <div className="left-menu">
                    <Link to="/#0t" className='home-logo'>
                        <Svg name="logo" />
                    </Link>
                </div>
            </div>
        </div>
    )
}
